import React, { useState } from "react"

const CommentCellDatenerfassung = ({

  value: initialValue,

  row: { index, original },

  column: { id },

  updateMethod, // This is a custom function that we supplied to our table instance
  deleteChange,
  whichDe

}) => {

  // We need to keep and update the state of the cell normally
  const status_id = original.status_id  || original.statusId;
  const status_enum = original.status;
  const [value, setValue] = useState(initialValue);
  const [state, setState] = useState('value-ori');


  const onChange = e => {
    setValue(e.target.value)
    if (!e.target.value) {
      setState('value-init');
      setValue(initialValue);
      deleteChange(index, id);
    } else {
      setState('value-update');
      updateMethod(index, id, e.target.value.replace(`${whichDe}: `, ''));
    }
  }

  const clickKomm = e => {
    e.preventDefault();
    if (initialValue.indexOf(`${whichDe}: `) === -1) {
      setValue('');
    } else {
      let target = initialValue.split(' | ')[0].replace(`${whichDe}: `, '');
      setValue(target);
    }

  }

  const unauthorized = (status, enumSt) => {
    if (status < 7 || enumSt === "zur Korrektur" || enumSt === "in Bearbeitung") {
      return false
    }
    return true
  }

  // If the initialValue is changed external, sync it up with our state

  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return <input type="text" value={value} onChange={onChange} 
  placeholder={initialValue}
  onClick={clickKomm} className={`${state} zahl-input`} 
  disabled={unauthorized(status_id, status_enum)}/>

}

export default CommentCellDatenerfassung
